"use strict";
import Barba from "barba.js";
import Env from "../base/env.js";
import Channels from "../base/channels";
import gsap from "gsap";
import ParallaxFx from "../fx/ParallaxFxVert";
import RevealFx from "../fx/RevealFx";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
import PlayerVideo from "../modules/Player";
import hcSticky from "hc-sticky";

let page;

class Page {
  constructor(view = "") {
    this.view = view;
    this.classView = "currentView--milleIndex";
    this.instanceStickies = [];
    // Launch Fn
    this.funcLaunch = this.intro.bind(this);
    if (Env.framework.UI.launcher.LAUNCHED == false) this.channels();
  }

  channels() {
    Channels.on("launcher::exit", this.funcLaunch);
  }

  destroy() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
    if (Env.mobileCSS == false) {
      for (let sticky of this.instanceStickies) {
        sticky.destroy();
      }
    }
  }

  finalize() {
    setTimeout(() => {
      if (Env.isVisiting === true) {
        this.intro();
      }
    }, Env.introBaseDelay);
    this.setupVideos();
    Env.framework.UI.lazy();
    this.fx();
  }

  fx() {
    // const $parallaxes = this.view.querySelectorAll(".jsParallaxY--view");

    // for (let $para of $parallaxes) {
    //   const instance = new ParallaxFx($para);
    //   instance.animate();
    // }

    const $stickies = this.view.querySelectorAll(".jsSticky--view");
    if (Env.mobileCSS == false) {
      for (let sticky of $stickies) {
        var Sticky = new hcSticky(sticky.querySelector(".jsStick"), {
          stickTo: sticky.querySelector(".jsContent"),
          top: 50,
        });
        this.instanceStickies.push(Sticky);
      }
    }

    const instance = new ParallaxFx(
      this.view.querySelector(".jsParallax--logo")
    );
    instance.animate();

    new RevealFx(this.view);

    if (this.view.querySelector(".jsScrollUp") != null) {
      this.view.querySelector(".jsScrollUp").addEventListener("click", () => {
        gsap.to(Env.$window, {
          scrollTo: { y: 0 },
          ease: "cubic.out",
          duration: 1,
        });
      });
    }
  }

  setupVideos() {
    const $players = this.view.querySelectorAll(".jsPlayer");
    for (let $player of $players) {
      const instance = new PlayerVideo($player);
      instance.setup();
    }
  }

  intro() {
    const $elementsA = [
      this.view.querySelectorAll(".jsIntroA"),
      this.view.querySelectorAll(".compo-type-a .fx"),
      this.view.querySelectorAll(".compo-type-a .visuals"),
    ];
    const $elementsB = [this.view.querySelectorAll(".jsIntroB")];
    const tl = gsap.timeline();

    tl.add([
      gsap.fromTo(
        $elementsA,
        { autoAlpha: 0, y: 10 },
        { autoAlpha: 1, y: 0, ease: "cubic.out", duration: 1, stagger: 0.2 }
      ),
      gsap.fromTo(
        $elementsB,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: "cubic.out", duration: 1, stagger: 0.2 }
      ),
    ]);
  }
}

page = Barba.BaseView.extend({
  namespace: "milleIndex",
  node: undefined,
  onEnter: function () {
    this.node = new Page(this.container);
    Env.$html.classList.add(this.node.classView);
  },
  onEnterCompleted: function () {
    this.node.finalize();
  },
  onLeave: function () {
    this.node.destroy();
  },
  onLeaveCompleted: function () {
    if (this.container.getAttribute("data-namespace") != this.namespace) {
      Env.$html.classList.remove(this.node.classView);
    }
  },
});

export default page;
